<template>
  <div class="w-100">
    <proa-card v-if="user" class="h-100 d-flex flex-column" :noHeaderBorder="$mq!=='sm'" no-padding>
      <template v-if="$mq==='sm'" v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading detail>{{ myself ? $t('common.subMenus.myPage') : pickedup ? $t('pages.member.pickupMember') : $t('pages.member.otherMember') }}</proa-heading>
          <div/>
        </div>
      </template>
      <template v-else v-slot:header>
        <div class="d-flex">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <div class="avatar-wrapper">
            <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" />
          </div>
          <div class="user-information-wrapper">
            <proa-heading sub>{{ user.meta.displayName }}</proa-heading>
            <div class="mt-2">
              <span>{{ currentOrganization.name }}</span>
              <span v-if="currentRole"> / {{ $t(`common.roleType.${currentRole.roleType}`) }}</span>
            </div>
            <div
              :class="['user-label my-1', { 'clickable': myself }]"
              @click="editUserLabelModal = myself"
            >
              <template v-if="myself">
                <img class="mr-1" :src="require('@/assets/images/icons/edit.png')"/>
                <span v-if="user.meta.userLabel">{{ user.meta.userLabel }}</span>
                <span v-else>{{ $t('models.user.unlabeled') }}</span>
              </template>
              <template v-else>
                <span>{{ user.meta.userLabel }}</span>
              </template>
            </div>
            <div class="user-status my-1">
              <template v-if="myself">
                <member-status-select
                  v-model="innerUserStatusType"
                  :options="userStatusTypes"
                  @input="onClickChangeUserStatusType"
                />
              </template>
              <template v-else>
                <div
                  v-if="user.meta.userStatusType && user.meta.userPresence == 'online'"
                  class="not-myself"
                >
                  <span
                    v-if="user.meta.userStatusType"
                    class="presence-icon"
                    :style="{ 'background-color': displayPresenceIconColor }"
                  />
                  <span>
                    {{ $t(`models.user.statusType.${ user.meta.userStatusType }`) }}
                  </span>
                </div>
                <span v-else>
                  {{ $t('models.user.unStatusType') }}
                </span>
              </template>
            </div>
            <div
              v-if="myself && organizations.length > 1"
              class="text-link clickable"
              @click="setSelectOrganizationModal(true)"
            >
              {{ $t('common.changeOrganization') }}
            </div>
          </div>
          <div class="assets-wrapper">
            <template v-if="!myself">
              <proa-button
                v-if="pickedup"
                :loading="togglePickupHttpRequesting"
                variant="secondary"
                @click.native="onClickTogglePickup('delete')"
              >
                {{ $t('common.deletePickupMember') }}
              </proa-button>
              <proa-button
                v-else
                :loading="togglePickupHttpRequesting"
                @click.native="onClickTogglePickup('add')"
              >
                {{ $t('common.addPickupMember') }}
              </proa-button>
            </template>
            <template v-if="myself">
              <proa-button
                :loading="false"
                variant="primary"
                @click.native="createNewOrganizationModal = true"
              >
                {{ $t('common.createNewOrganization') }}
              </proa-button>
            </template>
          </div>
        </div>
      </template>
      <template v-if="$mq==='sm'">
        <div class="d-flex sp-user-header">
          <div class="avatar-wrapper">
            <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" />
          </div>
          <div class="w-100 d-flex flex-column">
            <div class="user-information-wrapper">
              <proa-heading sub>{{ user.meta.displayName }}</proa-heading>
              <div class="mt-2">
                <span>{{ currentOrganization.name }}</span>
                <div v-if="currentRole">/ {{ $t(`common.roleType.${currentRole.roleType}`) }}</div>
              </div>
              <div
                :class="['user-label my-1', { 'clickable': myself }]"
                @click="editUserLabelModal = myself"
              >
                <template v-if="myself">
                  <img class="mr-1" :src="require('@/assets/images/icons/edit.png')"/>
                  <span v-if="user.meta.userLabel">{{ user.meta.userLabel }}</span>
                  <span v-else>{{ $t('models.user.unlabeled') }}</span>
                </template>
                <template v-else>
                  <span>{{ user.meta.userLabel }}</span>
                </template>
              </div>
              <div class="user-status my-1">
                <template v-if="myself">
                  <member-status-select
                    v-model="innerUserStatusType"
                    :options="userStatusTypes"
                    @input="onClickChangeUserStatusType"
                  />
                </template>
                <template v-else>
                  <div
                    v-if="user.meta.userStatusType"
                    class="not-myself"
                  >
                    <span
                      v-if="user.meta.userStatusType"
                      class="presence-icon"
                      :style="{ 'background-color': displayPresenceIconColor }"
                    />
                    <span>
                      {{ $t(`models.user.statusType.${ user.meta.userStatusType }`) }}
                    </span>
                  </div>
                  <span v-else>
                    {{ $t('models.user.unStatusType') }}
                  </span>
                </template>
              </div>
              <div
                v-if="myself && organizations.length > 1"
                class="text-link clickable"
                @click="setSelectOrganizationModal(true)"
              >
                {{ $t('common.changeOrganization') }}
              </div>
            </div>
            <div class="assets-wrapper">
              <template v-if="!myself">
                <proa-button
                  v-if="pickedup"
                  :loading="togglePickupHttpRequesting"
                  variant="secondary"
                  @click.native="onClickTogglePickup('delete')"
                >
                  {{ $t('common.deletePickupMember') }}
                </proa-button>
                <proa-button
                  v-else
                  :loading="togglePickupHttpRequesting"
                  @click.native="onClickTogglePickup('add')"
                >
                  {{ $t('common.addPickupMember') }}
                </proa-button>
              </template>
              <template v-if="myself">
                <proa-button
                  :loading="false"
                  variant="primary"
                  @click.native="createNewOrganizationModal = true"
                >
                  {{ $t('common.createNewOrganization') }}
                </proa-button>
              </template>
            </div>
          </div>
        </div>
      </template>
      <member-profile-tab
        :user="user"
        :myself="myself"
        :defaultMenu="defaultMenu"
      />
    </proa-card>
    <proa-modal
      :modal="editUserLabelModal"
      :title="$t('models.user.editUserLabel')"
      @close="editUserLabelModal = false"
    >
      <proa-input-group :label="$t('models.user.attributes.userLabel')">
        <template slot="input">
          <proa-input
            v-model="innerUserLabel"
            type="text"
            dark
          />
        </template>
      </proa-input-group>
      <template slot="footer">
        <proa-button
          @click.native="editUserLabelModal = false"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onClickChangeUserLabel"
          variant="primary"
        >
          {{ $t('common.change') }}
        </proa-button>
      </template>
    </proa-modal>
    <proa-modal
      :modal="editUserStatusTypeModal"
      :title="$t('models.user.editUserStatusType')"
      @close="editUserStatusTypeModal = false"
    >
      <proa-input-group :label="$t('models.user.attributes.userStatusType')">
        <template slot="input">
          <proa-select
            v-model="innerUserStatusType"
            :options="userStatusTypes"
          />
        </template>
      </proa-input-group>
      <template slot="footer">
        <proa-button
          @click.native="editUserStatusTypeModal = false"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onClickChangeUserStatusType"
          variant="primary"
        >
          {{ $t('common.change') }}
        </proa-button>
      </template>
    </proa-modal>
    <validation-observer v-slot="{ handleSubmit }">
      <form novalidate @submit.prevent="() => { newOrganizationValidated = true; handleSubmit(onSubmitCreateNewOrganization) }">
        <proa-modal
          :modal="createNewOrganizationModal"
          :title="$t('common.createNewOrganization')"
          @close="closeCreateNewOrganizationModal"
        >
          <div class="mb-4">{{ $t('common.modals.createNewOrganizationModal.message') }}</div>
          <validation-provider
            :name="$t('models.organization.attributes.name')"
            rules="required|max:50"
            v-slot="{ errors }"
          >
            <proa-input-group :invalidFeedback="newOrganizationValidated ? invalidOrganizationName ? $t('pages.confirmation.invalidOrganizationName') : errors[0] : null" class="mb-0">
              <template slot="input">
                <proa-input
                  v-model="newOrganizationName"
                  type="text"
                  :placeholder="$t('models.organization.attributes.name')"
                  :disabled="createNewOrganizationRequesting"
                  dark
                />
              </template>
            </proa-input-group>
          </validation-provider>
          <template slot="footer">
            <proa-button
              :disabled="createNewOrganizationRequesting"
              @click.native="closeCreateNewOrganizationModal"
              class="mr-2"
            >
              {{ $t('common.cancel') }}
            </proa-button>
            <proa-button
              :loading="createNewOrganizationRequesting"
              type="submit"
              variant="primary"
            >
              {{ $t('common.create') }}
            </proa-button>
          </template>
        </proa-modal>
      </form>
    </validation-observer>
    <proa-modal
      :modal="createdNewOrganizationModal"
      :title="$t('common.modals.createdNewOrganizationModal.title')"
      @close="closeCreatedNewOrganizationModal"
      hideCloseButton
    >
      <div class="text-pre-wrap">
        <span>{{ $t('common.modals.createdNewOrganizationModal.message') }}</span>
      </div>
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import camelCase from 'camelcase'
import i18n from '@/i18n'

import Role from '@/store/models/Role'
import User from '@/store/models/User'
import Organization from '@/store/models/Organization'
import MemberProfileTab from '@/components/organisms/MemberProfileTab'
import MemberStatusSelect from '@/components/molecules/member/MemberStatusSelect'
import ProaSelect from '../../atoms/ProaSelect.vue'

export default {
  name: 'ShowMember',
  components: {
    MemberProfileTab,
    MemberStatusSelect,
    ProaSelect
  },
  computed: {
    userId: function() { return this.$route.params.id },
    user: function() { return User.find(this.userId) },
    currentRole: function() { return Role.find(this.user.currentOrganizationRoleId) },
    organizations: function() { return Organization.all() },
    defaultMenu: function() {
      return this.$route.params.defaultMenu ?? camelCase(String(this.$route.query.default_menu))
    },
    myself: function() { return  this.userId == this.signedInUser.id },
    pickedup: function() {
      return this.signedInUser.favoriteUsers.map(favoriteUser => favoriteUser.userId).includes(this.userId)
    },
    userStatusTypes: function () {
      const userStatusTypesList = {
        normal: i18n.tc('models.user.statusType.normal'),
        // temporaryLeave: i18n.tc('models.user.statusType.temporaryLeave'),
        meeting: i18n.tc('models.user.statusType.meeting'),
        busy: i18n.tc('models.user.statusType.busy')
        // leave: i18n.tc('models.user.statusType.leave')
      }
      let statusTypes = []

      for (let [key, statusName] of Object.entries(userStatusTypesList)) {
        let statusTypesObj = {
          label: statusName,
          value: key,
          selected: key == this.user.meta.userStatusType,
          color: this.presenceIconColor(key)
        }
        statusTypes.push(statusTypesObj)
      }

      return [{
        label: i18n.tc('models.user.unStatusType'),
        value: null
      },
      ...statusTypes
      ]
    },
    displayPresenceIconColor: function () {
      let iconColor = ''
      switch(this.user.meta.userStatusType) {
        case 'normal':
          iconColor = '#46b4f0'
          break
        case 'meeting':
          iconColor = '#3ebe3e'
          break
        case 'busy':
          iconColor = '#f08200'
          break
      }
      return iconColor
    },
    ...mapGetters({
      httpError: 'httpError',
      setupDefault: 'setupDefault',
      signedInUser: 'auth/signedInUser',
      currentOrganization: 'auth/currentOrganization'
    })
  },
  data() {
    return {
      togglePickupHttpRequesting: false,
      editUserLabelModal: false,
      editUserStatusTypeModal: false,
      createNewOrganizationModal: false,
      createdNewOrganizationModal: false,
      createNewOrganizationRequesting: false,
      newOrganizationValidated: false,
      invalidOrganizationName: false,
      newOrganizationName: '',
      innerUserLabel: '',
      innerUserStatusType: ''
    }
  },
  methods: {
    setUserDetail: function() {
      if (this.myself) {
        this.innerUserLabel = this.user.meta.userLabel
      } else {
        this.apiGetUser(this.userId)
      }
    },
    closeCreateNewOrganizationModal: function() {
      if (this.createNewOrganizationRequesting) return
      this.createNewOrganizationModal = this.invalidOrganizationName = false
      this.newOrganizationName = ''
    },
    closeCreatedNewOrganizationModal: function() {
      location.href = '/'
    },
    presenceIconColor: function (statusValue) {
      let iconColor = ''
      switch(statusValue) {
        case 'normal':
          iconColor = '#46b4f0'
          break
        case 'meeting':
          iconColor = '#3ebe3e'
          break
        case 'busy':
          iconColor = '#f08200'
          break
      }
      return iconColor
    },
    async onClickTogglePickup(action) {
      let userFavoriteUsersAttributes
      if (action === 'add') {
        let listSequenceNo = 0
        if (this.signedInUser.favoriteUsers.length) {
          listSequenceNo = this.signedInUser.favoriteUsers.map(resource => resource.listSequenceNo)
                                                          .reduce((a, b) => { return Math.max(a, b) }) + 1
        }
        userFavoriteUsersAttributes = this.signedInUser.favoriteUsers.concat([{
          userId: this.userId,
          listSequenceNo: listSequenceNo
        }])
      } else {
        userFavoriteUsersAttributes = this.signedInUser.favoriteUsers.filter(resource => {
          return resource.userId != this.userId
        }).sort((first, second) => {
          return first.listSequenceNo - second.listSequenceNo
        }).map((favoriteUser, listSequenceNo) => {
          return { ...favoriteUser, ... {
            listSequenceNo: listSequenceNo
          }}
        })
      }
      this.togglePickupHttpRequesting = true
      await this.apiPutUserOrganization({
        userFavoriteUsersAttributes: userFavoriteUsersAttributes
      })
      this.togglePickupHttpRequesting = false
    },
    onClickBackButton: function() {
      // NOTE: 自身の詳細画面への遷移はサイドナビゲーションのアイコンからなのでhistory back
      if (this.myself) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'member' })
      }
    },
    async onClickChangeUserLabel() {
      await this.apiPutUserOrganization({
        userLabel: this.innerUserLabel
      })
      this.editUserLabelModal = false
    },
    async onClickChangeUserStatusType() {
      await this.apiPutUserStatusType({
        userStatusAttributes: {
          userStatusType: this.innerUserStatusType
        }
      })
      this.editUserStatusTypeModal = false
    },
    async onSubmitCreateNewOrganization() {
      this.createNewOrganizationRequesting = true
      await this.apiPostOrganization({
        name: this.newOrganizationName
      })
      if (this.httpError) {
        if (this.httpError.response?.data?.errors?.name) this.invalidOrganizationName = true
      } else {
        this.createdNewOrganizationModal = true
      }
      this.createNewOrganizationRequesting = false
    },
    ...mapMutations({
      setSelectOrganizationModal: 'setSelectOrganizationModal'
    }),
    ...mapActions({
      apiGetUser: 'entities/users/show',
      apiPutUserStatusType: 'auth/update',
      apiPutUserOrganization: 'userOrganization/update',
      apiPostOrganization: 'entities/organizations/create'
    })
  },
  watch: {
    userId() {
      this.setUserDetail()
    },
    setupDefault(value) {
      if (value) this.setUserDetail()
    }
  },
  created() {
    // NOTE: indexリクエストとshowリクエストの順序を制御するためにsetupDefaultをwatch
    if (this.setupDefault) this.setUserDetail()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.sp-user-header {
  padding: 20px 35px;

  .avatar-wrapper {
    margin-right: 10px;
  }

  .assets-wrapper {
    text-align: left;
    padding-right: 0;
    margin-top: 10px;
  }
}

.avatar-wrapper {
  margin: 0;

  @include mq(md) {
    margin: 20px 20px 30px 30px;
  }

  img {
    width: 60px !important;
    height: 60px !important;

    @include mq(md) {
      width: 80px !important;
      height: 80px !important;
    }
  }
}

.user-information-wrapper, .assets-wrapper {
  margin-top: 0;

  @include mq(md) {
    margin-top: 20px;
  }
}

.assets-wrapper {
  flex-grow: 1;
  text-align: right;
  padding-right: 20px;
}

.user-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: $light-text-color;

  img {
    width: 20px;
    height: 20px;
  }
}

.not-myself {
  display: flex;
  align-items: center;
  .presence-icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
